"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordError = void 0;
var PasswordError;
(function (PasswordError) {
    PasswordError[PasswordError["None"] = 0] = "None";
    PasswordError[PasswordError["Empty"] = 1] = "Empty";
    PasswordError[PasswordError["TooShort"] = 2] = "TooShort";
    PasswordError[PasswordError["TooLong"] = 3] = "TooLong";
    PasswordError[PasswordError["NotEnoughNumbers"] = 4] = "NotEnoughNumbers";
    PasswordError[PasswordError["NotEnoughSymbols"] = 5] = "NotEnoughSymbols";
    PasswordError[PasswordError["WhiteSpaceNotAllowed"] = 6] = "WhiteSpaceNotAllowed";
    PasswordError[PasswordError["NumbersNotAllowed"] = 7] = "NumbersNotAllowed";
    PasswordError[PasswordError["SymbolsNotAllowed"] = 8] = "SymbolsNotAllowed";
    PasswordError[PasswordError["NotAllowedSymbolsUsed"] = 9] = "NotAllowedSymbolsUsed";
    PasswordError[PasswordError["MustHaveUpperAndLowerCase"] = 10] = "MustHaveUpperAndLowerCase";
    PasswordError[PasswordError["OldPasswordNotCorrect"] = 100] = "OldPasswordNotCorrect";
    PasswordError[PasswordError["UserNotFound"] = 101] = "UserNotFound";
    PasswordError[PasswordError["PasswordMustNotMatchUserName"] = 102] = "PasswordMustNotMatchUserName";
})(PasswordError = exports.PasswordError || (exports.PasswordError = {}));
